import React from "react";
import {paramStore} from "../../../../../../stores";
import {account$} from "../../../../../../emitters/account";
import trim from "mn-utils/trim";
import {resendVerificationCode} from "../../utils/resendVerification";
import {BtnBlueFilled} from "../../../../../helpers/Buttons";
import {Box} from "@material-ui/core";

export default ({email}) => {
  const timerEnd$ = paramStore('e', 0);
  const initialTime = timerEnd$.getValue() - new Date().getTime();
  const [timeLeft, setTimer] = React.useState(initialTime);

  const minutes = String(Math.floor(timeLeft / 1000 / 60));
  const seconds = String(Math.floor(timeLeft / 1000 % 60));

  React.useEffect(() => {
    const timer = setInterval(() => {
      setTimer(timeLeft - 1000);
    }, 1000);

    if (timeLeft <= 0) {
      clearInterval(timer);
    }

    return () => {
      clearInterval(timer);
    };
  });

  const displayTime = (time) => time.length < 2 ? `0${time}` : time;

  return timeLeft > 0
    ? (
      <span>Resend in {displayTime(minutes)}:{displayTime(seconds)}</span>
    ) : (
      <Box width="25rem">
        <BtnBlueFilled
          onClick={() => {
            account$
              .resendConfirmationV2({
                email: trim(email),
              })
              .then(() => {
                timerEnd$.emit(new Date().getTime() + (60 * 1000));
                setTimer(60 * 1000);
              });
          }}
        >
          Resend verification code
        </BtnBlueFilled>
      </Box>
    )
}
